import { useEffect, useState } from "react";
import axios from "axios";

const portalUrl = '';

/* =========================
   SALARY API
   ========================= */
async function getSalary(page, pageSize) {
  const res = await fetch(
    `${portalUrl}/o/c/salaries?page=${page}&pageSize=${pageSize}`,
    {
      credentials: "include",
      headers: {
        "X-CSRF-Token": window.Liferay?.authToken,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  );

  if (!res.ok) {
    throw new Error("Failed to fetch salary data");
  }

  return res.json();
}

/* =========================
   COMPONENT
   ========================= */
export default function SalaryList() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const totalPages = Math.ceil(total / pageSize) || 1;

  /* =========================
     LOAD DATA
     ========================= */
  const load = async () => {
    setLoading(true);
    setRows([]);

    try {
      const response = await getSalary(page, pageSize);
      setRows(response.items || []);
      setTotal(response.totalCount || 0);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  useEffect(() => {
    load();
  }, [page, pageSize]);

  /* =========================
     PAGE NUMBERS (1 2 3 4)
     ========================= */
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 4;

    let start = Math.max(1, page - 1);
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  return (
    <>
      {/* =========================
         PAGE SIZE
         ========================= */}
      <div style={{ padding: 12 }}>
        <label>Page Size: </label>
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            setPage(1);
          }}
        >
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
      </div>

      {/* =========================
         TABLE
         ========================= */}
      <table className="tender-table" border="1" cellPadding="8" width="100%">
        <thead>
          <tr>
            <th>Name</th>
            <th>Branch</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>
          {loading && (
            <tr>
              <td colSpan="3" align="center">
                Loading...
              </td>
            </tr>
          )}

          {!loading && rows.length === 0 && (
            <tr>
              <td colSpan="3" align="center">
                No data available
              </td>
            </tr>
          )}

          {!loading &&
            rows.map((r, i) => (
              <tr key={i}>
                <td>{r.name}</td>
                <td>{r.branch}</td>
                <td>{r.amount}</td>
              </tr>
            ))}
        </tbody>
      </table>

      {/* =========================
         PAGINATION
         ========================= */}
      <div
        style={{
          marginTop: 12,
          display: "flex",
          gap: 6,
          alignItems: "center",
        }}
      >
        <button onClick={() => setPage(1)} disabled={page === 1}>
          First
        </button>

        <button
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page === 1}
        >
          Prev
        </button>

        {getPageNumbers().map((p) => (
          <button
            key={p}
            onClick={() => setPage(p)}
            style={{
              fontWeight: p === page ? "bold" : "normal",
              background: p === page ? "#ddd" : "white",
              border: "1px solid #aaa",
              padding: "4px 8px",
            }}
          >
            {p}
          </button>
        ))}

        <button
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          disabled={page === totalPages}
        >
          Next
        </button>

        <button
          onClick={() => setPage(totalPages)}
          disabled={page === totalPages}
        >
          Last
        </button>

        <span style={{ marginLeft: 8 }}>
          Page {page} of {totalPages}
        </span>
      </div>
    </>
  );
}
